import { configureStore } from "@reduxjs/toolkit";
import {
  createStateSyncMiddleware,
  initMessageListener,
  initStateWithPrevTab,
  withReduxStateSync,
} from "redux-state-sync";
import { combineReducers } from "redux";

import layersReducer from "./layers.js";
import interfaceReducer from "./interface.js";
import annotationsReducer from "./annotations.js";
import textAnnotationsReducer from "./textAnnotations.js";
import filtersReducer from "./filters.js";
import authReducer from "./auth.js";
import inspectionReducer from "./inspection.js";
import usersReducer from "./users.js";
import potreeReducer from "./potree.js";
import officesReducer from "./offices.js";
import projectsReducer from "./projects.js";

const rootReducer = combineReducers({
  layers: layersReducer,
  interface: interfaceReducer,
  annotations: annotationsReducer,
  textAnnotations: textAnnotationsReducer,
  filters: filtersReducer,
  auth: authReducer,
  inspection: inspectionReducer,
  users: usersReducer,
  potree: potreeReducer,
  offices: officesReducer,
  projects: projectsReducer
});

export const storeCreator = ({ channel }) => {
  // console.log(`configure store in channel ${channel}`);
  const store = configureStore({
    reducer: withReduxStateSync(rootReducer),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(createStateSyncMiddleware({ channel })),
  });
  // initMessageListener(store);
  // init state with other tabs
  initStateWithPrevTab(store);

  return store;
};
